import {getImageSources, ImageSources, SIZES} from '@vio/atlas/Image'
import {ImageProvider} from '@vio/core/src/staticContent/types/ImageProvider'

// Desktop screens top out at 2x, so denser screens pick the 2x candidate.
const DENSITIES = [1, 1.5, 2]

/** Crops the image to the desktop card slot at each density, with the 1x crop as the fallback src. */
export const getCardImageSources = (
  url: string,
  imageProvider: ImageProvider
): ImageSources => {
  if (!url) return {src: '', srcSet: ''}

  try {
    return getImageSources(url, SIZES.desktopCard, imageProvider, {
      densities: DENSITIES,
      resizingType: 'fill'
    })
  } catch {
    return {src: url, srcSet: ''}
  }
}
